import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import "./index.scss";

// Añado condición de sí hay value forzar el shrink para evitar que los campos autocompletados o con
// cambios de state (sin tocar el input) se quede el label por encima del value y no se ejecute la animación
const InputComponent = (props) => {
  const [shrink, setShrink] = useState(false);

  return <TextField className={"input"} variant={"outlined"} onFocus={() => setShrink(true)} onBlur={() => setShrink(false)} {...props} InputLabelProps={{ shrink: shrink || props.value ? true : false }} />;
};

export default InputComponent;